import React from 'react';

const AccountButton = ({ text, onClick, secondary }) => (
  <button
    className={`account-button ${secondary ? 'secondary' : ''}`}
    onClick={onClick}
  >
    {text}
  </button>
);

export default AccountButton;